import { render, staticRenderFns } from "./GiveFiledCopyOfNoticeErpInstructions.vue?vue&type=template&id=6e281eea"
import script from "./GiveFiledCopyOfNoticeErpInstructions.vue?vue&type=script&lang=ts"
export * from "./GiveFiledCopyOfNoticeErpInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports